import { Pipe, PipeTransform } from '@angular/core';
import { ConstantsService } from 'src/app/services/constants/constants.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Pipe({
    name: 'i18nRehireStatusPipe',
    standalone: false
})
export class i18nRehireStatusPipe implements PipeTransform {

  constructor(){}
  transform(value: string) {
    if(value) {
      value = ConstantsService.profileStatus[value]
        ? ConstantsService.profileStatus[value]
        : value
    }
    return value
  }
}

@Pipe({
    name: 'i18nProfileStatusPipe',
    standalone: false
})
export class i18nProfileStatusPipe implements PipeTransform {

  constructor(private permission: PermissionsService) { }

  transform(value: any) {
    value = ConstantsService.profileStatuses[value] ?? value;
    return value
  }
}